import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectors } from '@clearscore-group/lib.redux.market';
import useTracking from '@clearscore-group/lib.hooks.use-tracking';
import { getCookie } from '@clearscore-group/lib.helpers.cookies';

/**
 * UTM tags shoul be preffered way to track website visits.
 * This is used for tracking events which can be sent by agencies in cases
 * where `utm` tags just don't cut it.
 */

function attachTracking(webSiteTrack) {
  if (typeof window !== 'undefined') {
    if (!window.__cs__) {
      window.__cs__ = {};
    }
    window.__cs__.webSiteTrack = window.__cs__.webSiteTrack || webSiteTrack;
  }
}
var useWebsiteTracking = function useWebsiteTracking() {
  var track = useTracking();
  var locale = useSelector(selectors.getActiveLocale);
  var TRACK_FBP = getCookie('_fbp');
  var TRACK_FBC = getCookie('_fbc');
  var webSiteTrack = useCallback(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name,
      _ref$props = _ref.props,
      _props = _ref$props === void 0 ? {} : _ref$props,
      onComplete = _ref.onComplete;
    var date = new Date();
    return track({
      name: name,
      props: _objectSpread(_objectSpread(_objectSpread({
        cs_ed: date,
        language: locale,
        page_url: window.location.href,
        url: window.location.href
      }, TRACK_FBP && {
        fbp: TRACK_FBP
      }), TRACK_FBC && {
        fbc: TRACK_FBC
      }), _props),
      onComplete: onComplete
    });
  }, [track, locale, TRACK_FBC, TRACK_FBP]);
  attachTracking(webSiteTrack);
  return webSiteTrack;
};
export default useWebsiteTracking;